(function () {
    'use strict';
    angular
        .module('app')
        .factory('manualRelationshipsService', manualRelationshipsService);
    manualRelationshipsService.$inject = ['$http', '$q', '$filter'];
    function manualRelationshipsService($http, $q, $filter) {
        var service = {
            loading: false,
            getChildren: getChildren,
            setManualRelationships: setManualRelationships
        };
        return service;

        // Get direct children of any relationship type.
        // Returns XRefReturnPacketModel.
        function getChildren(tableNumber, fileId, majRev, minRev) {
            service.loading = true;
            var deferred = $q.defer();
            var url = '../Synergis.WebApi/api/Relationships/Children/';
            url = url.concat(tableNumber + '/' + fileId + '/' + majRev + '/' + minRev);
            $http.get(url).then(function (response) {
                service.loading = false;
                deferred.resolve(response.data);
            }, function (response) {
                service.loading = false;
                deferred.reject(response);
            });
            return deferred.promise;
        }

        // Set manual relationships for a document.
        // Returns SetRelationshipsResults.
        function setManualRelationships(tableNumber, fileId, majRev, minRev, xRefNodeModelList) {
            service.loading = true;
            var deferred = $q.defer();
            var url = '../Synergis.WebApi/api/Relationships/Manual/';

            //Bill 08-31-2018 #25767 PW-P2A is not creating a fixed relationship as it should
            //     Added fixFloat parameter to WebAPI controller, passing in an illegal value of '0' to use the system defaults
            //     Legal values are fi(x), floa(T), (D)ock
            url = url.concat(tableNumber + '/' + fileId + '/' + majRev + '/' + minRev + "/0");

            $http({
                url: url,
                method: 'POST',
                data: JSON.stringify(xRefNodeModelList),
                headers: {
                    "Content-Type": "application/json"
                }
            }).then(function (response) {
                service.loading = false;
                deferred.resolve(response.data);
            }, function (response) {
                service.loading = false;
                deferred.reject(response);
            });
            return deferred.promise;
        }

    }
})();